import { Dialog, DialogActions, DialogContent } from '@mui/material';
import React, { useState, useEffect } from 'react';
import SelectTermsTemplate from '../../../finance/termsTemplate/section/SelectTermsTemplate';
import AppCKEditor from '../../../../../../components/AppInput/AppCKEditor';


function ContentSection({ caption, field, value, callBack, isPrinting }) {

    const [dialogStatus, setDialogStatus] = useState(false);
    const [inputText, setInputText] = useState("");
    
    useEffect(() => {
        if (value !== null && value !== undefined) {
            setInputText(value);
        }
    }, [value]);

    const update = () => {
        let payload = {};
        payload[field] = inputText;
        callBack(payload);
        setDialogStatus(false);
    };

    return (
        <>
            <span style={{ whiteSpace: 'pre-line' }}>
                {(value == null || value === "") && !isPrinting ? (
                    <span type="button" className='text-muted' onClick={() => setDialogStatus(true)} >{caption}</span>
                ) : (
                    <span 
                        type="button" 
                        onClick={() => setDialogStatus(true)} 
                        dangerouslySetInnerHTML={{ __html: value }} 
                    />
                )}
            </span>
            
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={() => setDialogStatus(false)}
                fullWidth={true}
                maxWidth="lg"
                disableEnforceFocus 
            >
                <DialogContent>
                    <div className='row align-items-start'>
                        <div className='col-md-8'>
                            {/* Reusable Editor Instance */}
                            <AppCKEditor value={inputText} setValue={setInputText} />
                        </div>
                        <div className='col-md-4'>
                            <SelectTermsTemplate callBack={setInputText} />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn btn-outline-primary' onClick={() => setDialogStatus(false)}>Cancel </button>
                    <button className='btn btn-success' onClick={update}>Update</button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ContentSection;